export default __webpack_public_path__ + "static/media/arrow.3fcc2908.gif";